import {
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';

import {
  Router,
  ActivatedRoute
} from '@angular/router';

import {UserService} from '../../services/user.service';
import {NotificationService} from '../../services/notification.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy{
  password = null;
  success = null;
  private _sub;
  private _routeParams = {};

  constructor(private _user: UserService, private _notification: NotificationService, public translate: TranslateService,
    private _router: Router, private _route: ActivatedRoute){

  }

  ngOnDestroy(){
    this._sub.unsubscribe();
  }

  ngOnInit(){
    this._sub = this._route.params.subscribe(params => {
      this._routeParams = params;
    })
  }

  passwordSecured(){
    return this._user.passwordSecured(this.password);
  }

  resetPassword(){
    if (!this.passwordSecured()){
      this._notification.errorClient('MESSAGE.ERROR.UNSECURE_PASSWORD');
      return;
    }
    this._user.resetPassword(this.password, this._routeParams['id'], this._routeParams['token']).subscribe(
      res => {
        this.success = true;
      },
      err => { this._notification.errorServer(err); }
    );
  }

  cancel(){
    this._router.navigate(['login'], {queryParams: { loggedOut: 'true' }});
  }
}
